import { render, staticRenderFns } from "./licDetail4G.vue?vue&type=template&id=463bcdc8&scoped=true&"
import script from "./licDetail4G.vue?vue&type=script&lang=js&"
export * from "./licDetail4G.vue?vue&type=script&lang=js&"
import style0 from "./licDetail4G.vue?vue&type=style&index=0&id=463bcdc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463bcdc8",
  null
  
)

export default component.exports